export const TYPING_SEARCH = "TYPING_SEARCH";

export const UPDATE_STATUS_SEARCH = "UPDATE_STATUS_SEARCH";

export const SEARCH_WITH_KEYWORD = "SEARCH_WITH_KEYWORD";
export const SEARCH_WITH_KEYWORD_SUCCESS = "SEARCH_WITH_KEYWORD_SUCCESS";
export const SEARCH_WITH_KEYWORD_FAILED = "SEARCH_WITH_KEYWORD_FAILED";

export const RESET_DATA_SEARCH = "RESET_DATA_SEARCH";
